module.exports = "<form> <radio group=r1 :items=items selected=red></radio> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/forms/radio-demo.vue
 ** module id = 285
 ** module chunks = 0
 **/